import { headerData } from "@/utils/Header";
import { Box, Flex, HStack, Link, Text } from "@chakra-ui/react";
import { Fragment } from "react";

const MobileNavbar = () => {
	return (
		<Box
			// bg="brand.white300"
			h="100%"
			pos="fixed"
			top="4rem"
			left="0"
			w="100%"
			zIndex="99"
		>
			<Box
				bg="brand.blue400"
				mt="0rem"
				px={["1rem", "2rem", "3rem"]}
				py="2rem"
				w="100%"
				borderBottomLeftRadius=".6rem"
				borderBottomRightRadius=".6rem"
			>
				<HStack
					alignItems="left"
					display={["block", "block", "block", "none"]}
					justifyContent="space-between"
					fontSize="1.05rem"
					fontWeight="500"
					spacing={0}
				>
					{headerData.map((item, idx) => {
						return (
							<Fragment key={idx}>
								<Link href={item.url || ""}>
									<Flex
										align="center"
										justify="left"
										columnGap="2rem"
										my="2rem"
									>
										<Text
											textAlign="left"
											color="brand.gray100"
											_hover={{
												color: "brand.gold200",
											}}
										>
											{item.title}
										</Text>
									</Flex>
								</Link>
							</Fragment>
						);
					})}
				</HStack>
			</Box>
		</Box>
	);
};

export { MobileNavbar };
